import React, { useState, useEffect, useRef, useContext, useMemo, useCallback } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  Grid,
  OutlinedInput,
  CircularProgress,
  Checkbox,
  ListItemText,
  Button,
} from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

import {
  IconButton,
  Modal
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { l3lossSave, orLossBucketsData } from "Samarth Module/api/orltAPI";
import { useMsal } from "@azure/msal-react";
import { SelectedAlertsContext } from "utils/SelectedAlertContext";
import editIcon from '../icons/editIcon.png'
const COLORS_L1 = ["#007BFF", "#00C49F", "#FFC107", "#BB86FC"];
const COLORS_L2 = [
  "#FFCDD2",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#FF9F40",
  "#9966FF",
  "#8AC24A",
  "#F06292",
];

// L1 to L2 indices mapping
const L1_L2_INDEX_MAPPING = {
  "RMPM Shortfall": [0, 1, 2, 3, 4],
  "Warehouse Congestion Led Loss": [5, 6, 7],
};

const getL2IndicesForL1 = (l1Names) => {
  if (!l1Names || l1Names.length === 0) return [];
  const indices = new Set();
  l1Names.forEach(name => {
    const mappedIndices = L1_L2_INDEX_MAPPING[name];
    if (mappedIndices) mappedIndices.forEach(idx => indices.add(idx));
  });
  return Array.from(indices).sort((a, b) => a - b);
};

const initialFields = [
  { reason: '', number: '' },
  { reason: '', number: '' },
  { reason: '', number: '' },
  { reason: '', number: '' },
  { reason: '', number: '' },
]
const OrLossDetails = ({tblView}) => {
  const { orLossTreeSelectedFilters } = useContext(SelectedAlertsContext);
  const { accounts } = useMsal();
  const activeAccount = accounts[0];
  const userEmail = activeAccount?.username;

  const [hoverL1, setHoverL1] = useState(null);
  const [hoverL2, setHoverL2] = useState(null);
  const [selectedL1, setSelectedL1] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedL2, setSelectedL2] = useState([]);
  const [selectedL2Indices, setSelectedL2Indices] = useState([]);
  const [L1_DATA, setL1Data] = useState([]);
  const [L2_DATA, setL2Data] = useState([]);
  const [loss1Percentage, setLoss1Percentage] = useState(0);
  const [loss2Percentage, setLoss2Percentage] = useState(0);
  const [openModal, setOpen] = useState(false)
  const [loss3, setLoss3] = useState(initialFields)
  // eslint-disable-next-line no-unused-vars
  const [l3LossBackup, setL3LossBackup] = useState([])
  const [_selectedL2, _setSelectedL2] = useState('Loss 2')
  const [l3lossLoader, setL3LossLoader] = useState(false)
  const [message, setMessage] = useState("")  

  const [data, setData] = useState(null)
  const [api_loading, setLoading] = useState(false)

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        setData(null)
        const response = await orLossBucketsData(orLossTreeSelectedFilters, tblView);
        if (isMounted && typeof response === 'object') {
          setData(response);
        }
      } catch (err) {
        console.error("Donut chart error", err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    fetchData();

    return () => {
      isMounted = false;
    };
  }, [orLossTreeSelectedFilters, tblView]);

  useEffect(() => {
    if (!data) return;

    const processLossData = (lossObj, colors, excludeKey) =>
      Object.entries(lossObj)
        .filter(([key]) => key !== excludeKey)
        .map(([key, value], index) => ({
          name: key,
          value: +value,
          color: colors[index % colors.length],
        }));

    const l1 = processLossData(data["Loss 1"], COLORS_L1, "Loss1_percentage");

    const apiData = data["Loss 2"]
    const desiredOrder = [
      "Plan Variation Led Loss",
      "PR PO Conversion Led Loss",
      "Delayed PO Delivery Led Loss",
      "QC Inspection Led Loss",
      "Other RMPM Shortfall Led loss",
      "Planning Led Loss",
      "Dispatch Compliance Led Loss",
      "Other Congestion Led Loss",
      "Loss2_percentage"
    ];

    const orderedData = {};
    for (const key of desiredOrder) {
      if (apiData.hasOwnProperty(key)) {
        orderedData[key] = apiData[key];
      }
    }
    data["Loss 2"] = orderedData
    const l2 = processLossData(data["Loss 2"], COLORS_L2, "Loss2_percentage");
    setL1Data(l1);
    setL2Data(l2);
    setLoss1Percentage(data["Loss 1"]?.Loss1_percentage || 0);
    setLoss2Percentage(data["Loss 2"]?.Loss2_percentage || 0);
  }, [data]);

  const handleL1Change = (event) => setSelectedL1(event.target.value);

  const getSelectedIndices = (selectedNames, dataset) =>
    dataset
      .map((item, index) => (selectedNames.includes(item.name) ? index : null))
      .filter((index) => index !== null);

  const selectedL1Indices = getSelectedIndices(selectedL1, L1_DATA);


  const openPopup = (val) => {
    if (val === 'Loss 2') return;
    setOpen(true);
    _setSelectedL2(val)

    if (Array.isArray(l3LossBackup) && l3LossBackup.length > 0) {
      const eml = userEmail || email
      const filter = l3LossBackup.filter((a) => a?.Loss2 === val && a?.email === eml)
      if (filter.length > 0) setLoss3(filter)
      setTimeout(() => {
        const scrollableDiv = document.getElementById('l3lossId');
        if (scrollableDiv) {
          scrollableDiv.scrollBy({
            top: 100000,
            left: 0,
          });
        }
      }, 100)
    }
  }
  const closePopup = () => {
    setOpen(null);
    _setSelectedL2('Loss 2')
    setLoss3(initialFields)
    setMessage("")
  };

  const email = "user@unilever.com"
  const getL3LossData = async () => {
    // const res = await l3LossGetResponse(userEmail || email, tblView)
    // if (Array.isArray(res)) {
    //   setL3LossBackup(res);
    // }
  }

  useEffect(() => {
    getL3LossData()
  }, [])

  const submitL3Loss = async () => {
    const obj = {
      "Loss2": _selectedL2,
      "email": userEmail || email,
      "details": (Array.isArray(loss3) ? loss3.filter((o) => (o?.reason && o?.number)) : []),
      "view": tblView
    }
    setL3LossLoader(true)
    const res = await l3lossSave(obj)
    if (res?.message) {
      setMessage(res?.message)
      getL3LossData()
    }
    setL3LossLoader(false)
  }


  useEffect(() => {
    if (hoverL1 !== null) {
      const l1Name = L1_DATA[hoverL1]?.name;
      setSelectedL2Indices(l1Name ? getL2IndicesForL1([l1Name]) : []);
    } else if (selectedL1.length > 0) {
      setSelectedL2Indices(getL2IndicesForL1(selectedL1));
    } else {
      setSelectedL2Indices([]);
    }
  }, [hoverL1, L1_DATA, selectedL1]);

  // Calculate related L2 sum when L1 is selected
  const relatedL2Sum = useMemo(() => {
    if (selectedL2Indices.length === 0) {
      return loss2Percentage;
    }
    return selectedL2Indices.reduce((sum, index) => sum + (L2_DATA[index]?.value || 0), 0);
  }, [selectedL2Indices, L2_DATA, loss2Percentage]);

  if (!data || api_loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const onChangeLoss3 = (e, i) => {
    const { name, value } = e.target;

    if (name === 'number' && value.length > 9) {
      return;
    }
    setLoss3(prev => {
      const updated = [...prev];
      updated[i] = { ...updated[i], [name]: value };
      return updated;
    });
  }

  const renderPopupChart = () => {
    if (!openModal) return null;

    const inputstyle = {
      height: '26px',
      padding: '4px',
      marginRight: '5px',
      marginLeft: '5px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      marginBottom: '10px',
      width: '200px'
    };

    const addNewRecord = () => {
      setLoss3((prev) => ([...prev, { reason: '', number: '' }]))
      setTimeout(() => {
        const scrollableDiv = document.getElementById('l3lossId');
        if (scrollableDiv) {
          scrollableDiv.scrollBy({
            top: 100000,
            left: 0,
          });
        }
      }, 70)
    }
    if (message) {
      return (
        <Modal open={true} onClose={closePopup}>
          <Box
            sx={{
              position: "absolute",
              top: "20%",
              left: "30%",
              width: "40%",
              bgcolor: "background.paper",
              // borderRadius: 2,
              p: 2,
              pt: 1,
              boxShadow: 24,
              outline: "none"
            }}
          >

            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography variant="subtitle1" sx={{ pt: 1 }}></Typography>
              <IconButton onClick={closePopup}><Close /></IconButton>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", my: 1, ml: '20px' }}>
              <Box sx={{ width: 'fit-content', }}>
                <Box sx={{ width: 'fit-content', color: '#044216', background: '#8ebd8a', p: '10px', px: '74px', borderRadius: '5px' }}>
                  ✔ L3 Loss saved successfully!
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      );
    }
    return (
      <Modal open={true} onClose={closePopup}>
        <Box
          sx={{
            position: "absolute",
            top: "20%",
            left: "30%",
            width: "40%",
            bgcolor: "background.paper",
            // borderRadius: 2,
            p: 2,
            pt: 1,
            boxShadow: 24,
            outline: "none"
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, borderBottom: '1px solid #ddd' }}>
            <Typography variant="subtitle1" sx={{ pt: 1 }}>L3 Loss</Typography>
            <IconButton onClick={closePopup}><Close /></IconButton>
          </Box>
          {(l3lossLoader) && <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                position: 'absolute',
                left: '46%',
                zIndex: 6,
                top: '90px'
              }}
            >
              <CircularProgress />
            </Box>
          </Box>}
          <Box sx={{ display: "flex", justifyContent: "center", my: 1, ml: '20px' }}>
            <Box sx={{ width: 'fit-content', }}>
              <Box sx={{ width: 'fit-content', overflowY: "auto", maxHeight: '278px' }} id="l3lossId">
                {loss3.map((obj, i) => {
                  return <Box sx={{ display: "flex" }}>
                    <Box sx={{ position: 'relative' }}>
                      <input
                        name='reason'
                        style={inputstyle}
                        placeholder={"Reason " + (i + 1)}
                        value={obj?.reason}
                        onChange={(e) => onChangeLoss3(e, i)}
                      />
                      <img src={editIcon} alt="edit icon" style={{ position: 'absolute', top: '10px', right: '10px' }} />
                    </Box>
                    <Box sx={{ position: 'relative' }}>
                      <input
                        name="number"
                        type="number"
                        style={inputstyle}
                        placeholder="Enter Number"
                        value={obj?.number}
                        onChange={(e) => onChangeLoss3(e, i)}
                      />

                      <img src={editIcon} alt="edit icon" style={{ position: 'absolute', top: '10px', right: '10px' }} />
                      {(loss3.length - 1 === i) && <Box
                        onClick={() => addNewRecord()}
                        sx={{
                          position: 'absolute',
                          right: '-19px',
                          top: '-7px',
                          fontSize: '30px',
                          color: '#054e8e',
                          cursor: 'pointer'
                        }}>+</Box>}
                    </Box>
                  </Box>
                })}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-around', my: 2 }}>
                <Button sx={{
                  color: '#fff',
                  background: '#d4d3d3',
                  textTransform: 'capitalize',
                  width: '140px',
                }}
                  onClick={() => closePopup()}
                >Cancel</Button>
                <Button sx={{
                  color: '#fff',
                  background: '#162ba7',
                  textTransform: 'capitalize',
                  width: '140px',
                  marginRight: '40px'
                }}
                  disabled={l3lossLoader}
                  onClick={() => submitL3Loss()}
                >Submit</Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  };

  return (
    <>
      {renderPopupChart()}
      <Box
        sx={{
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
          pt: 0,
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "14px" }}>
          OR Loss Details
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            "& .MuiOutlinedInput-root": {
              // border: "1px solid #e0e0e0",
              borderRadius: 1,
              fontSize: "12px",
              height: "30px",
            },
            "& .MuiSelect-select": {
              padding: "6px 8px",
            },
            "& .MuiMenuItem-root": {
              fontSize: "12px",
            },
          }}
        >

          <Select
            multiple
            size="small"
            displayEmpty
            value={selectedL1}
            onChange={handleL1Change}
            input={<OutlinedInput />}
            renderValue={(selected) =>
              selected.length === 0 ? "L1 Loss" : `${selected.length} selected`
            }
            sx={{ width: "fit-content", height: '30px', fontSize: "12px" }}
          >
            {L1_DATA.map((item, index) => (
              <MenuItem key={index} value={item.name} sx={{
                padding: '5px',
                '& .MuiTypography-root': {
                  fontSize: '12px',
                },
              }} >
                <Checkbox checked={selectedL1.includes(item.name)} size="medium" sx={{ padding: '2px' }} />
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>

          <Select
            size="small"
            value={_selectedL2}
            onChange={(e) => openPopup(e.target.value)}
            sx={{ fontSize: "12px", height: "30px", minWidth: "90px" }}
            placeholder="Loss 2"
          >
            <MenuItem sx={{
              padding: '5px',

              fontSize: '12px',

            }} value="Loss 2">Loss 2</MenuItem>
            {L2_DATA.map((item, index) => (
              <MenuItem key={index} value={item.name} sx={{ padding: '5px', fontSize: '12px' }} >
                {item.name}
              </MenuItem>
            ))}

          </Select>
        </Box>
      </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={2.9}>
          {L1_DATA.map((item, index) => {
            const isHovered = hoverL1 === index;
            const isSelected =
              selectedL1.length === 0 || selectedL1.includes(item.name);
            const opacity =
              hoverL1 !== null ? (isHovered ? 1 : 0.3) : isSelected ? 1 : 0.3;
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  opacity,
                  mb: 1,
                }}
              >
                <span
                  style={{
                    backgroundColor: item.color,
                    height: "42px",
                    width: "3px",
                    marginRight: 8,
                  }}
                />
                <Typography sx={{ fontSize: "8px", lineHeight: 1.2, marginTop: "9%", maxWidth: item.name.length > 3 ? "45px" : "auto", overflowWrap: item.name.length > 3 ? "break-word" : "normal", whiteSpace: item.name.length > 3 ? "pre-wrap" : "normal" }}>
                  <strong>{item.value}%</strong> <br />
                  {item.name}
                </Typography>
              </Box>
            );
          })}
        </Grid>

        <Grid item xs={12} md={3.1}>
          <DonutChart
            data={L1_DATA}
            hoveredIndex={hoverL1}
            selectedIndices={selectedL1Indices}
            onHover={(val) => {
              setHoverL1(val === hoverL1 ? null : val)
              setHoverL2(null)
            }}
            label="L1 Loss"
            value={loss1Percentage.toFixed(2)}
          />
        </Grid>

        <Grid item xs={12} md={3.1}>
          <DonutChart
            data={L2_DATA}
            hoveredIndex={hoverL2}
            selectedIndices={selectedL2Indices}
            onHover={(val) => {
              setHoverL2(hoverL1 === val ? null : val)
              setHoverL1(null)
            }

            }
            label="L2 Loss"
            value={relatedL2Sum.toFixed(2)}
          />
        </Grid>

        <Grid item xs={12} md={2.9}>
          <Grid container spacing={1}>
            {(() => {
              const highlightedL2Names = [];
              const dimmedL2Names = [];
              if (
                L1_DATA[hoverL1]?.name === "Warehouse Congestion Led Loss" ||
                selectedL1.includes("Warehouse Congestion Led Loss")
              ) {
                highlightedL2Names.push(
                  "Dispatch Compliance Led Loss",
                  "Planning Led Loss",
                  "Other Congestion Led Loss"
                );
                dimmedL2Names.push(
                  "Delayed PO Delivery Led Loss",
                  "Other RMPM Shortfall Led loss",
                  "PR PO Conversion Led Loss",
                  "Plan Variation Led Loss",
                  "QC Inspection Led Loss"
                );
              }
              if (
                L1_DATA[hoverL1]?.name === "RMPM Shortfall" ||
                selectedL1.includes("RMPM Shortfall")
              ) {
                highlightedL2Names.push(
                  "Delayed PO Delivery Led Loss",
                  "Other RMPM Shortfall Led loss",
                  "PR PO Conversion Led Loss",
                  "Plan Variation Led Loss",
                  "QC Inspection Led Loss"
                );
                dimmedL2Names.push(
                  "Dispatch Compliance Led Loss",
                  "Planning Led Loss",
                  "Other Congestion Led Loss"
                );
              }
              return [0, 4].map((start, col) => (
              <Grid item xs={6} key={col}>
                {L2_DATA.slice(start, start + 4).map((item, index) => {
                  const adjustedIndex = start + index;
                  const isHovered = hoverL2 === adjustedIndex;
                  const isSelected = selectedL2.includes(item.name);
                  const isDimmed = dimmedL2Names.includes(item.name);
                  const isHighlighted = highlightedL2Names.includes(item.name);
                  let opacity = 1;
                  if (hoverL2 !== null) {
                    opacity = isHovered ? 1 : 0.3;
                  } else {
                    if (isHighlighted || isSelected) opacity = 1;
                    else if (!isSelected && selectedL2.length > 0) opacity = 0.3;
                    else if (isDimmed && !isSelected) opacity = 0.3;
                    else opacity = 1;
                  }

                  return (
                    <Box
                      key={adjustedIndex}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        opacity,
                        mb: 1,
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: item.color,
                          height: "42px",
                          width: "3px",
                          marginRight: 8,
                        }}
                      />
                      <Typography sx={{ fontSize: "8px", lineHeight: 1.2, maxWidth: item.name.length > 3 ? "45px" : "auto", overflowWrap: item.name.length > 3 ? "break-word" : "normal", whiteSpace: item.name.length > 3 ? "pre-wrap" : "normal" }}>
                        <strong>{item.value}%</strong> <br />
                        {item.name}
                      </Typography>
                    </Box>
                  );
                })}
              </Grid>
            ));
            })()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default OrLossDetails;

const DonutChart = ({
  data,
  hoveredIndex,
  selectedIndices,
  onHover,
  label,
  value,
}) => {
  const chartRef = useRef(null);
  const onPieEnter = (_, index) => {
    onHover(index);
  };
  const onPieLeave = useCallback(() => {
    onHover(null);
  }, [onHover]);




  useEffect(() => {
    function handleClickOutside(event) {
      if (chartRef.current && !chartRef.current.contains(event.target)) {
        onPieLeave()
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onPieLeave]);




  return (
    <div ref={chartRef}>
      <ResponsiveContainer width="100%" height={150}>
        <PieChart
        // onMouseLeave={onPieLeave}
        // onClick={onPieLeave}
        > {/* ✅ Fix added here */}
          <circle cx="50%" cy="50%" r="60" fill="#E6F2FF" />
          <Pie
            data={data}
            innerRadius={40}
            outerRadius={60}
            dataKey="value"
            // onMouseEnter={onPieEnter}
            onClick={onPieEnter}
            isAnimationActive={false}

          >
            {data.map((entry, index) => {
              const isHovered = hoveredIndex === index;
              const isSelected =
                selectedIndices.length === 0 || selectedIndices.includes(index);
              const opacity =
                hoveredIndex !== null
                  ? isHovered
                    ? 1
                    : 0.3
                  : isSelected
                    ? 1
                    : 0.3;
              return (
                <Cell
                  key={index}
                  fill={entry.color}
                  opacity={opacity}
                  stroke="#fff"
                  strokeWidth={1.2}
                  style={{ outline: 'none' }}
                />
              );
            })}
          </Pie>
          <text
            x="50%"
            y="46%"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="10"
            fill="#333"
          >
            {hoveredIndex !== null && data && data[hoveredIndex]
              ? data[hoveredIndex].name
              : label}
          </text>
          <text
            x="50%"
            y="58%"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="14"
            fontWeight="bold"
            fill="#333"
          >
            {hoveredIndex !== null && data && data[hoveredIndex]
              ? data[hoveredIndex].value.toFixed(2)
              : value}%
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
